<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :cell-style="{
            'font-size': '16px',
            color: '#333',
        }"
        :header-cell-style="{
            'background-color': '#e8eff9',
            'font-weight': '700',
            color: '#333',
            'font-size': '16px',
        }"
    >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="ID" align="center" header-align="center">
            <template slot-scope="scope">
                <div>
                    {{ scope.$index + 1 }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="课时名称"
            prop="total"
            align="center"
            header-align="center"
            sortable
        >
        </el-table-column>
        <el-table-column
            label="姓名"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="手机号（账号）"
            prop="type"
            align="center"
            header-align="center"
        >
            <template slot-scope="scope">
                <div style="cursor: pointer">
                    {{ scope.row.type }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="批次号/班级编码"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="签到状态"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="签到时间"
            prop="type"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="签到截止时间"
            prop="total"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="签退状态"
            prop="signingUp"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="签退时间"
            prop="learning"
            align="center"
            header-align="center"
        >
        </el-table-column>
        <el-table-column
            label="开始签退时间"
            prop="notLearn"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="评分情况"
            prop="studyOver"
            align="center"
            header-align="center"
        ></el-table-column>
        <el-table-column
            label="评分内容"
            prop="learnNum"
            align="center"
            header-align="center"
        ></el-table-column>
    </el-table>
</template>

<script>
import { getSignList, exportSignList } from "@/api/FaceToTeach/classTimeapi.js";
export default {
    data() {
        return {
            tableData: [],
            multipleSelection: [],
        };
    },
    methods: {
        async init() {
            const res = await getSignList({
                teacherCourseBatchId: this.courseId,
            });
            console.log(res.data.data);
            this.tableData = res.data.data.list;
        },
        // 表格选中
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
    },
    created() {
        this.init();
    },
    props: {
        courseId: {
            type: String,
        },
        selectTableData: {
            type: Array,
        },
        page: {
            type: Object,
        },
    },
    watch: {
        selectTableData: function () {
            this.tableData = this.selectTableData;
        },
        page: {
            immediate: true,
            deep: true,
            handler: async function (newValue) {
                if (newValue) {
                    // 课时管理table数据
                    const res = await getSignList({
                        teacherCourseBatchId: this.courseId,
                        page: newValue.page,
                        pageSize: newValue.pageSize,
                    });
                    this.tableData = res.data.data.list;
                    this.$emit("total", this.tableData.length);
                }
            },
        },
    },
};
</script>

